import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { ReactComponent as EditIcon } from "images/edit_blue.svg";
import { ReactComponent as CopyIcon } from "images/copy.svg";
import { ReactComponent as DeleteIcon } from "images/trash.svg";
import { ReactComponent as LinkIcon } from "images/link.svg";
import Tag from "ui-components/molecules/tag/tag";
import { TagColor } from "app/data/common/tagColor";
import "./cloneWeek.scss";

const columnHelper = createColumnHelper<any>();

export const getStatusColor = (status: string) => {
  switch (status) {
    case "ACTIVE":
      return TagColor.GREEN;
    case "INACTIVE":
      return TagColor.RED;
    default:
      return TagColor.GREY;
  }
}
export const getWeeks = (
  handleOpen: (weekStartDate: string) => void,
  handleClone: (weekStartDate: string, division: string) => void,
  handleEdit: (
    weekStartDate: string,
    division: string,
    weekDescription: string,
    scheduleType: string,
    status: string,
    dispatches?: number,
    createdAt?: string,
    lastModifiedAt?: string,
  ) => void,
  handleDelete: (weekStartDate: string, division: string) => void) => [
    columnHelper.accessor("weekStartDate", {
      header: "Week",
      size: 120,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("description", {
      header: "Description",
      size: 300,
      cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("dispatches", {
      header: "Dispatches",
      size: 130,
      cell: info => info.getValue() != null ? <div>{info.getValue()}</div> : '-',
    }),

    columnHelper.accessor("status", {
      header: "Status",
      size: 130,
      cell: info => info.getValue() ? <div><Tag mods={{ color: getStatusColor(info.getValue()) }}>{info.getValue().toLowerCase().capitalize()}</Tag></div> : '-',
    }),


    columnHelper.accessor("action", {
      header: "Action",
      size: 280,
      cell: info => <div style={{ display: 'flex', gap: '8px' }}>
        <div title="Link" onClick={() => handleOpen(info.row.original.weekStartDate)}>
          <div className="clone-week-table-container__actions">
            <LinkIcon className="clone-week-btn__icon" />Open
          </div>
        </div>
        <div title="Copy" onClick={() => handleClone(info.row.original.weekStartDate, info.row.original.division)}>
          <div className="clone-week-table-container__actions">
            <CopyIcon className="clone-week-btn__icon" />Copy
          </div>
        </div>
        <div title="Edit" onClick={() => handleEdit(
          info.row.original.weekStartDate,
          info.row.original.division,
          info.row.original.description,
          info.row.original.scheduleType,
          info.row.original.status,
          info.row.original.dispatches,
          info.row.original.createdAt,
          info.row.original.lastModifiedAt,
        )}>
          <div className="clone-week-table-container__actions">
            <EditIcon className="clone-week-btn__icon" />Edit
          </div>
        </div>
        {info.row.original.scheduleType !== 'MASTER' && info.row.original.status !== 'ACTIVE' && <div title="Delete" onClick={() => handleDelete(info.row.original.weekStartDate, info.row.original.division)}>
          <div className="clone-week-table-container__actions__delete">
            <DeleteIcon className="clone-week-btn__delete_icon" />Delete
          </div>
        </div>}
      </div>,
    }),

  ];
